import gql from 'graphql-tag';
import bundleOrderItem from './cartQuery/bundleOrderItem.fragment.graphql.js';
import flightOrderItem from './cartQuery/flightOrderItem.fragment.graphql.js';
import hotelOrderItem from './cartQuery/hotelOrderItem.fragment.graphql.js';
import seatOrderItem from './cartQuery/seatOrderItem.fragment.graphql.js';
import travelerAncillaryOrderItem from './cartQuery/travelerAncillaryOrderItem.fragment.graphql.js';
import vehicleOrderItem from './cartQuery/vehicleOrderItem.fragment.graphql.js';
import itineraryAncillaryOrderItem from './cartQuery/itineraryAncillaryOrderItem.fragment.graphql.js';
import showOrderItem from './cartQuery/showOrderItem.fragment.graphql.js';

import travelers from './cartQuery/travelers.fragment.graphql.js';

export const cartFragments = {
  items: {
    flightOrderItem,
    bundleOrderItem,
    seatOrderItem,
    travelerAncillaryOrderItem,
    itineraryAncillaryOrderItem,
    hotelOrderItem,
    vehicleOrderItem,
  },
  travelers,
};

export default gql`
  ${bundleOrderItem}
  ${flightOrderItem}
  ${hotelOrderItem}
  ${seatOrderItem}
  ${travelerAncillaryOrderItem}
  ${vehicleOrderItem}
  ${itineraryAncillaryOrderItem}
  ${showOrderItem}
  ${travelers}
  query cart {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          allowedHotelSaleDestinations
          enableAllowedHotelSaleDestinations
          enableExcludedVehicleSaleDestinations
          excludedVehicleSaleDestinations
        }
      }
    }
    order {
      hasPendingCSAdjustments
      orderNumber
      items {
        id
        __typename
        ...BundleOrderItemFragment
        ...FlightOrderItemFragment
        ...HotelOrderItemFragment
        ...SeatOrderItemFragment
        ...TravelerAncillaryOrderItemFragment
        ...VehicleOrderItemFragment
        ...ItineraryAncillaryOrderItemFragment
        ...ShowOrderItemFragment
      }
      ...TravelersFragment
      price {
        total
        balanceDue
        totalDueToday
        totalDueAtHotelCheckout
        taxes {
          amount
        }
        fees {
          amount
        }
      }
      payments {
        ... on PromoPayment {
          id
          description
          total {
            amount
            currency
          }
        }
        ... on LoyaltyPayment {
          id
          paymentMethod
          total {
            amount
          }
        }
      }
      isInternational
    }
    settings {
      uplift {
        pages {
          pageName
          pageValue
        }
      }
    }
  }
`;
